import { render, staticRenderFns } from "./ApiConfiguration.vue?vue&type=template&id=aaf45c20&scoped=true"
import script from "./ApiConfiguration.vue?vue&type=script&lang=js"
export * from "./ApiConfiguration.vue?vue&type=script&lang=js"
import style0 from "./ApiConfiguration.vue?vue&type=style&index=0&id=aaf45c20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf45c20",
  null
  
)

export default component.exports